"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toKebabCase = void 0;
/**
 * Converts a string to kebab-case.
 * @param str - The input string to convert
 * @returns The kebab-case version of the string
 * @example
 * toKebabCase('ProgramTag') // 'program-tag'
 * toKebabCase('myVariableName') // 'my-variable-name'
 * toKebabCase('some string here') // 'some-string-here'
 */
const toKebabCase = (str) => {
    if (str == null)
        return '';
    return String(str)
        .trim()
        .toLowerCase()
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-');
};
exports.toKebabCase = toKebabCase;
